export const common = {
  download: 'Letöltés',
  loading: 'Betöltés...',
  save: 'Mentés',
  cancel: 'Mégse',
  edit: 'Szerkesztés',
  delete: 'Törlés',
  create: 'Létrehozás',
  search: 'Keresés...',
  logout: 'Kijelentkezés',
  close: 'Bezárás',
  noData: 'Nincs megjeleníthető adat',
  error: 'Hiba',
  reload: 'Újratöltés',
  select_language: 'Nyelv kiválasztása',
  dateFilter: 'Szűrés dátum szerint',
  showing: 'Megjelenítve {{count}} bejegyzés',
  exportExcel: 'Exportálás Excelbe',
  inDevelopment: 'Fejlesztés alatt',
  whatsNew: 'Legújabb újítások',
  version: 'Verzió',
  systemUnderDevelopment: 'A rendszer folyamatos fejlesztés alatt áll',
  actions: {
    edit: 'Szerkesztés',
    save: 'Mentés',
    cancel: 'Mégse',
    delete: 'Törlés',
    create: 'Létrehozás',
    view: 'Megtekintés',
    close: 'Bezárás',
    share: 'Megosztás'
  },
  back: 'Vissza',
  next: 'Tovább',
  profile: {
    title: 'Profil beállítások',
    personalInfo: 'Személyes adatok',
    fullName: 'Teljes név',
    email: 'Email cím',
    phone: 'Telefonszám',
    organization: 'Szervezeti adatok',
    organizationName: 'Szervezet neve',
    taxNumber: 'Adószám',
    registrationNumber: 'Cégjegyzékszám',
    organizationStatus: 'Szervezet státusza',
    changePassword: 'Jelszó módosítása',
    currentPassword: 'Jelenlegi jelszó',
    newPassword: 'Új jelszó',
    confirmPassword: 'Új jelszó megerősítése',
    updatePassword: 'Jelszó módosítása'
  },
  messages: {
    confirmDelete: 'Biztosan törölni szeretnéd ezt az elemet?',
    deleteWarning: 'Ez a művelet nem visszavonható. Az elem véglegesen törlődik.',
    profile: {
      updateSuccess: 'A profil sikeresen frissítve',
      updateError: 'Hiba történt a profil frissítése közben',
      passwordMismatch: 'A megadott jelszavak nem egyeznek',
      passwordChangeSuccess: 'A jelszó sikeresen módosítva',
      passwordChangeError: 'Hiba történt a jelszó módosítása közben'
    },
    linkCopied: 'Link másolva a vágólapra',
    shareError: 'Hiba történt a link megosztása közben',
    authContext: {
      error: 'Hiba történt a felhasználó adatok betöltése közben',
      signInSuccess: 'Sikeres bejelentkezés!',
      signInError: 'Sikertelen bejelentkezés',
      signOutSuccess: 'Sikeres kijelentkezés!',
      signOutError: 'Sikertelen kijelentkezés',
      invalidCredentials: 'Hibás e-mail cím vagy jelszó',
      userDisabled: 'Ez a felhasználói fiók le van tiltva',
      tooManyRequests: 'Túl sok sikertelen próbálkozás. Kérjük, próbálja újra később'
    },
    customer: {
      failedToLoad: 'Hiba történt a ügyfelek betöltése közben',
      createdSuccess: 'Ügyfél sikeresen létrehozva',
      createdError: 'Hiba történt a ügyfél létrehozása közben',
      updatedSuccess: 'Ügyfél sikeresen frissítve',
      updatedError: 'Hiba történt a ügyfél frissítése közben',
      deletedSuccess: 'Ügyfél sikeresen törölve',
      deletedError: 'Hiba történt a ügyfél törlése közben',

      customerStatusUpdated: 'Ügyfél státusza frissítve:  ',
      customerStatusUpdateFailed: 'Hiba történt a ügyfél státusz frissítése közben'
    },
    quotation: {
      createSuccess: 'Árajánlat sikeresen létrehozva',
      createError: 'Hiba történt a árajánlat létrehozása közben',
      offerStatusUpdated: 'Árajánlat státusza frissítve:  ',
      offerStatusUpdateFailed: 'Hiba történt a árajánlat státusz frissítése közben',
      updateStatus: "Kattints a státusz módosításához"
    },
    organization: {
      emailNotFound: 'Nem található felhasználó ezzel az email címmel',
      userAlreadyExists: 'Ez a felhasználó már tagja ennek a szervezetnek',
      userAdded: 'Felhasználó sikeresen hozzáadva',
      userInvited: 'Felhasználó sikeresen meghívva',
      userAddError: 'Hiba történt a felhasználó hozzáadása közben',
      userRemoved: 'Felhasználó sikeresen eltávolítva',
      userRemoveError: 'Hiba történt a felhasználó eltávolítása közben',

      createdSuccess: 'Szervezet sikeresen létrehozva',
      createdError: 'Hiba történt a szervezet létrehozása közben',
      updateSuccess: 'Szervezet sikeresen frissítve',
      updateError: 'Hiba történt a szervezet frissítése közben',
      deleteSuccess: 'Szervezet sikeresen törölve',
      deleteError: 'Hiba történt a szervezet törlése közben',

      logoUploadSuccess: 'Logó sikeresen feltöltve',
      logoUploadError: 'Hiba történt a logó feltöltése közben',
      logoDeleteSuccess: 'Logó sikeresen eltávolítva',
      logoDeleteError: 'Hiba történt a logó eltávolítása közben',
    },
    copyError: 'Hiba történt a link másolása közben',
    documentGenerationStarted: 'Dokumentum generálás elindítva:',
    alerts: {
      noActiveAlerts: 'Jelenleg nincsenek aktív riasztások',
      systemHealthy: 'A rendszer minden komponense megfelelően működik',
      criticalAlerts: 'kritikus',
      warningAlerts: 'figyelmeztetés',
      closeAll: 'Összes bezárása',
      closeAlert: 'Riasztás bezárása',
      levels: {
        critical: 'KRITIKUS',
        error: 'HIBA',
        warning: 'FIGYELEM',
        info: 'INFO'
      },
      messages: {
        providerError: 'Provider {{provider}} feldolgozási hiba',
        authenticationFailed: 'SFTP hitelesítési hiba - jelszó ellenőrzés szükséges',
        connectionError: 'Kapcsolódási hiba - hálózat vagy szerver probléma',
        unknownError: 'Ismeretlen {{provider}} feldolgozási hiba',
        errorWithTime: '{{details}} ({{minutes}} perce)',
        highMemoryUsage: 'Magas memóriahasználat észlelve',
        memoryDetails: 'Csúcs memória: {{maxMemory}} MB ({{processCount}} folyamat érintett)',
        staleData: '{{provider}} adatok elavultak',
        staleDataDetails: 'Utolsó frissítés: {{days}} napja',
        staleDataWarning: 'Utolsó frissítés: {{days}} napja - Automatikus szinkronizálás szükséges',
        slowProcessing: '{{provider}} lassú feldolgozás',
        slowProcessingDetails: 'Feldolgozási idő: {{duration}} perc ({{records}} rekord)',
        poorDataQuality: '{{provider}} adatminőség gyenge',
        qualityDetails: 'Adatteljesség: {{completeness}}% ({{invalidMeasurements}} hibás mérés)',
        statisticsSummary: '{{count}} {{type}}'
      }
    },
    monitoring: {
      autoRefresh: 'Auto-frissítés',
      refreshNow: 'Frissítés most'
    }
  },
  placeholders: {
    selectOrg: 'Válasszon szervezetet...',
    selectCustomer: 'Válasszon ügyfelet...',
    selectProduct: 'Válasszon terméket...',
    selectQuotation: 'Válasszon árajánlatot...',
    notes: 'További megjegyzések az árajánlathoz...',
    itemNotes: 'Megjegyzés ehhez a tételhez...',
    quotationNotes: 'Általános megjegyzések az árajánlathoz...',
    email: 'Email cím...',
    unitPlaceholder: 'pl.: darab, óra, nap',
    deals: "Válasszon ügyletet..."
  },
  page: {
    notFound: 'Oldal nem található',
    returnToDashboard: 'Vissza a vezérlőpultra'
  },
  settings: {
    title: 'Beállítások',
  },
  pagination: {
    showing: 'Megjelenítve',
    itemsPerPage: 'db/oldal',
    of: 'összesen',
    to: 'a',
    results: 'eredmény'
  },
  accept: 'Elfogadás',
  deny: 'Elutasítás',
  add: 'Hozzáadás',
  remove: 'Eltávolítás',
  uploading: 'Feltöltés...',
  modifiedBy: 'Módosította',
  submit: 'Küldés',
  submitting: 'Küldés folyamatban...',
  onboarding: {
    skip: 'Kihagyás',
    next: 'Tovább',
    back: 'Vissza',
    finish: 'Befejezés'
  }
}